import CountryFlag from "../CountryFlag";

import {
  BoxLabel,
  CountyWrapper,
  Heading,
  Label,
  ListLabel,
  Wrapper,
} from "./WidgetRow.styled";

export const WidgetRow = ({ item, between, code = "" }) => {
  const title = item?.key;
  const isBoxLabel = item?.label && item?.value;

  const renderLabels = () => {
    if (Array.isArray(item?.label)) {
      return (
        <ListLabel>
          {item?.label.map((lbl, index) => (
            <li key={index}>
              <Label labelStatus={item?.labelStatus} label={lbl} />
            </li>
          ))}
        </ListLabel>
      );
    }

    return <Label labelStatus={item?.labelStatus} label={item?.label} />;
  };

  const renderValue = () => {
    if (item.id === "country") {
      return (
        <CountyWrapper>
          <CountryFlag
            countryCode={code?.toLowerCase()}
            countryName={item.value}
          />
          <span>
            {item.value} ({code})
          </span>
        </CountyWrapper>
      );
    }

    return <span>{item?.value}</span>;
  };

  return (
    <div>
      <Wrapper label={item?.label} between={between}>
        <Heading>{title}</Heading>

        {item?.label && renderLabels()}
        {!item?.label && <BoxLabel>{renderValue()}</BoxLabel>}
      </Wrapper>

      {item?.label && (
        <BoxLabel isBoxLabel={isBoxLabel}>{item?.value}</BoxLabel>
      )}
    </div>
  );
};
